import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { WithEnterpriseIds } from '../../../../../types';
import { LockableRateInputField } from './LockableFields';
import { CommonFields } from './CommonFields';
import {
    BASE_PRICE_FIELD_NAME,
    EXTRA_OCCUPANCY_ADJUSTMENT_FIELD_NAME,
    NEGATIVE_OCCUPANCY_ADJUSTMENT_FIELD_NAME,
} from './fieldNames';
import { FieldName, WithFieldsConfig } from './types';

type BaseRateFieldsProps = WithEnterpriseIds &
    WithFieldsConfig & {
        selectedRateIds?: string[];
        unlockField?: (fieldName: FieldName) => void;
    };

export const BaseRateFields = ({ enterpriseIds, fieldsConfig, selectedRateIds, unlockField }: BaseRateFieldsProps) => (
    <CommonFields
        unlockField={unlockField}
        selectedRateIds={selectedRateIds}
        fieldsConfig={fieldsConfig}
        enterpriseIds={enterpriseIds}
    >
        <LockableRateInputField
            name={BASE_PRICE_FIELD_NAME}
            label={<LocalizedText textKey={TextKey.BasePrice} />}
            fieldsConfig={fieldsConfig}
            onUnlock={() => (unlockField ? unlockField(BASE_PRICE_FIELD_NAME) : null)}
            required
        />
        <LockableRateInputField
            name={EXTRA_OCCUPANCY_ADJUSTMENT_FIELD_NAME}
            label={<LocalizedText textKey={TextKey.ExtraOccupancyAdjustment} />}
            fieldsConfig={fieldsConfig}
            onUnlock={() => (unlockField ? unlockField(EXTRA_OCCUPANCY_ADJUSTMENT_FIELD_NAME) : null)}
        />
        <LockableRateInputField
            name={NEGATIVE_OCCUPANCY_ADJUSTMENT_FIELD_NAME}
            label={<LocalizedText textKey={TextKey.NegativeOccupancyAdjustment} />}
            fieldsConfig={fieldsConfig}
            onUnlock={() => (unlockField ? unlockField(NEGATIVE_OCCUPANCY_ADJUSTMENT_FIELD_NAME) : null)}
        />
    </CommonFields>
);
